import reducer from './reducer';
import * as selectors from './selectors';

const exportedObject = { reducer, selectors};
export default exportedObject;
